/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
/**
 *
 * `PageGroupsOrganizationDetail` shows summary details of a group, and it's members.
 *
 *
 * ```
 * <Page::Groups::Organization::Detail
 *   @group={{foo}}
 *   @rawGroupPolicy={{bar}}
 *   @members={{array bar baz}}
 *   @groupLevelPermissions={{array bar baz}}
 *   @eligibleMembers={{array bar baz}}
 *   @organization={{organization}}
 *   @scimEnabled={{false}}
 *   @truncatedResourceName='my-awesome-...'
 *   @isProjectContext={{true}}
 * />
 * ```
 *
 * @class PageGroupsOrganizationDetail
 *
 */

export default class PageGroupsOrganizationDetailComponent extends Component {
  /**
   * @argument group
   * @type {Object}
   */
  /**
   * @argument rawGroupPolicy
   * @type {<Object>}
   */
  /**
   * @argument members
   * @type {Array<Object>}
   */
  /**
   * @argument groupLevelPermissions
   * @type {Array<String>}
   */
  /**
   * @argument eligibleMembers
   * @type {Array<Object>}
   */
  /**
   * @argument organization
   * @type {Object}
   */
  /**
   * @argument scimEnabled
   * @type {Boolean}
   */
  /**
   * @argument truncatedResourceName
   * @type {String}
   */
  /**
   * @argument isProjectContext
   * @type {Boolean}
   */
  @service abilities;

  @tracked isActive = false;

  get canUpdateGroup() {
    const { group, groupLevelPermissions } = this.args;

    if (!groupLevelPermissions || !group) {
      return false;
    }
    return this.abilities.can('update group', group, {
      groupLevelPermissions,
    });
  }

  get shouldShowAddMembers() {
    const { eligibleMembers, group, groupLevelPermissions } = this.args;

    if (!groupLevelPermissions || !group || !eligibleMembers) {
      return false;
    }

    const hasEligibleMembers = eligibleMembers.length > 0;

    return (
      hasEligibleMembers &&
      this.abilities.can('update-membership in group', group, {
        groupLevelPermissions,
      })
    );
  }

  toggleDeleteModal = () => {
    this.isActive = !this.isActive;
  };
}
